<template>
  <div class="sort">
    <div class="sort-left">
      <div class="sort-left__header">已掌握{{masterNumber}}人</div>
      <ul v-if="masterNumber > 0">
        <li v-for="item in masterList" :key="item.student_id">
          <span
            v-if="item.code_ability>=20&&item.code_ability<70"
            style="color:#F99830">{{item.student_name}} ({{item.code_ability}} %)</span>
            <span
              v-else
              style="color:#67C23A">{{item.student_name}} ({{item.code_ability}} %)</span>
        </li>
      </ul>
      <div class="sort-left__text" v-else>
        <button class="sort-left__text__button yellow" @click="skip"
        v-if="Number($route.query.classType) === 1">布置知识点针对练习>></button>
        <div class="sort-left__text__fz">当前还没有学生掌握该知识点，快去给学生提升一下吧~</div>
      </div>
    </div>
    <div class="sort-right">
      <div class="sort-right__header">未掌握 {{unMasterNumber}} 人</div>
      <ul v-if="unMasterNumber > 0">
        <li v-for="item in unMasterList" :key="item.student_id" style="color:#F56C6C">
          {{item.student_name}}
          <span>({{item.code_ability}} %)</span>
        </li>
      </ul>
      <div class="sort-right__text" v-else>
        很棒哦，没有未掌握的学生～
      </div>
    </div>
  </div>
</template>

<script>
import storeCreator from '@/utils/store-creator';

export default {
  props: {
    masterList: {
      type: Array,
    },
    unMasterList: {
    },
    row: {},
    requestCondition: {},
  },
  computed: {
    masterNumber() {
      return this.masterList.length;
    },
    unMasterNumber() {
      return this.unMasterList.length;
    },
  },
  methods: {
    showAnalysis() {
      this.$emit('showAnalysis');
    },
    skip() {
      const store = storeCreator.create('pt');
      if (Number(this.$route.query.classType) === 1) {
        store.set('selectedList', JSON.stringify([this.row]));
      }
      this.$router.push({
        name: 'CreateWeakSpot',
        query: {
          subjectId: this.requestCondition.subjectId,
          className: this.requestCondition.className,
          testId: this.requestCondition.testId,
          testName: this.requestCondition.testName,
          classId: this.requestCondition.classId,
          subjectName: this.requestCondition.subjectName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .yellow {
    color: #FFA82D;
    border: 1px solid #FFA82D
  }
  .blue {
    border: 1px solid #1989FA;
    color: #1989FA;
  }
  .sort {
    display: flex;
    font-family: PingFangSC-Medium, PingFang SC;
    &-left {
      position: relative;
      text-align: center;
      width: 50%;
      min-height: 300px;
      border-right: 1px solid #F5F7FA;
      &__header {
        height: 48px;
        background: #F0F2F5;
        border-radius: 4px 0px 0px 4px;
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        line-height: 48px;
        text-align: center;
      }
      &__text {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        &__fz {
          color: #606266;
          font-size: 15px;
        }
        &__button {
          width: 174px;
          height: 40px;
          margin-right: 30px;
          margin-bottom: 30px;
          border-radius: 4px;
          font-size: 15px;
          font-weight: 500;
        }
      }
      li {
        float: left;
        width: 25%;
        height: 48px;
        line-height: 48px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #606266;
        border-bottom: 1px solid #F5F7FA;;
      }
    }
    &-right {
      width: 50%;
      min-height: 300px;
      position: relative;
      &__header {
        height: 48px;
        background: #E0E6F3;
        border-radius: 0px 4px 4px 0px;
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        line-height: 48px;
        text-align: center;
      }
      &__text {
        font-size: 15px;
        color: #606266;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
      }
      li {
        float: left;
        width: 25%;
        height: 48px;
        line-height: 48px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #606266;
        border-bottom: 1px solid #F5F7FA;;
      }
    }
  }
</style>
